import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminCategories from "@/pages/admin/AdminCategories";

export const Route = createFileRoute("/admin/categorias")({
  head: () => seoHead({
    title: "Administração | Shopping do Bem",
    description: "Área administrativa do Shopping do Bem.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminCategories />
    </AdminRoute>
  ),
});
